import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import bbqLogo from '../assets/bbq-logo.png';
import PosterCarousel from '../PosterCarousel';

function Login() {
    const [name, setName] = useState('');
    const navigate = useNavigate();

    // Check if user is already logged in
    useEffect(() => {
        const existingName = Cookies.get('bbq_user_name');
        if (existingName) {
            navigate('/home', { state: { name: existingName } });
        }
    }, [navigate]);

    const handleSubmit = async () => {
        if (!name.trim()) return;

        try {
            const response = await fetch('/api/join', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name }),
            });

            const data = await response.json();
            if (response.ok) {
                // Store name in cookie (expires in 24 hours)
                Cookies.set('bbq_user_name', name.trim(), { expires: 1 });
                navigate('/home', { state: { name: name.trim() } });
            } else {
                alert(data.error || 'Something went wrong');
            }
        } catch (err) {
            console.error(err);
            alert('Could not connect to server.');
        }
    };

    return (
        <div className="app compact-layout">
            <img src={bbqLogo} alt="BBQ Logo" className="logo top-logo" />

            <PosterCarousel />

            <div className="input-section">
                <br />
                <p className="name-instruction">Please use your real name for everyones experience</p>
                <input
                    type="text"
                    placeholder="Enter your name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    className="name-input"
                    onKeyPress={e => e.key === 'Enter' && handleSubmit()}
                />
                <button onClick={handleSubmit} className="join-button">
                    Join the Party
                </button>
            </div>
        </div>
    );
}

export default Login; 